export default __webpack_public_path__ + "static/media/icons8-copy-96.ddb4fec1.svg";